import { CollaborateurDTO, DossierDTO, LoginInfoDTO, TravailDTO, UserType } from '@logaia_users/logaia-dto';

/**
 * Saisie autorisée dans le travail en cours du dossier (bureau DossierContext.IsSaisieTravailAutorise et
 * TravailService.IsTravailBloque) : ouvre le dossier annuel et la saisie dans la période du travail.
 * Autorisé : aucun travail, compte d'assistance (type Assistance, ou login « ASSLG » de l'ancien front), créateur du
 * travail, login de la liste des autorisés (casse ignorée), ou collaborateur affecté au dossier en expert, réviseur
 * ou collaborateur (affectations 1 à 3 ; l'affectation 4, social, ne suffit pas).
 */
export function saisieTravailAutorisee(
  travail: TravailDTO | null | undefined,
  dossier: Pick<DossierDTO, 'collabsAffectation1' | 'collabsAffectation2' | 'collabsAffectation3'>,
  user: Pick<LoginInfoDTO, 'login' | 'userType'>,
  codeCollab: string | null | undefined,
): boolean {
  if (!travail) {
    return true;
  }
  const l = user.login.toLowerCase();
  if (user.userType === UserType.Assistance || l === 'asslg') {
    return true;
  }
  if (travail.loginCreation?.toLowerCase() === l || travail.loginAutorises.some((t) => t.login.toLowerCase() === l)) {
    return true;
  }
  const affecte = (c: CollaborateurDTO[] | null) => !!c?.some((a) => a?.codeCollab === codeCollab);
  return !!codeCollab && [dossier.collabsAffectation1, dossier.collabsAffectation2, dossier.collabsAffectation3].some(affecte);
}
